import { Shovel } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceArea } from "@prisma/client";

const servicesSection = {
  type: SECTION_TYPES.SERVICES,
  content: {
    header: "Our Services",
    overline: null,
  },
  meta: {
    displayName: "Services",
    displayDescription: "Tell your customers about the services you offer.",
    displayIcon: Shovel,
    variantsCount: 9,
  },
  aiPrompt(serviceArea: ServiceArea) {
    return `Return a brief title for the header of the services section. It should be very concise and to the point
      ${
        serviceArea?.name
          ? `and include the area name e.g. "Services we provide in ${serviceArea.name}" or "Services we offer in ${serviceArea.name}.`
          : ""
      }
      `;
  },
};

export default servicesSection;
